import { useTranslation } from 'react-i18next'
import type { ChapterReportView } from '@/types/chapterReport'

function formatDate(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value.slice(0, 10)
  return new Intl.DateTimeFormat('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date).replace(/\.$/, '')
}

function formatGrade(value: string): string {
  const elementaryGrade = value.match(/(?:elementary|초등?\s*)[_ -]?(\d+)|^(\d+)학년$/i)
  const grade = elementaryGrade?.[1] ?? elementaryGrade?.[2]
  return grade ? `초${grade}` : value
}

export function ChapterReportHeader({ report }: { report: ChapterReportView }) {
  const { t } = useTranslation('coaching')

  return (
    <header className="flex flex-wrap items-center justify-between gap-4 border-b border-[#d0d0d0] pb-8">
      <div className="flex items-center gap-3 px-2">
        <img
          src="/report/diagnostic/logo_kor.svg"
          alt={t('chapterReport.title')}
          className="h-6 w-[119px]"
        />
        <span className="h-3.5 w-px bg-[#d0d0d0]" aria-hidden="true" />
        <strong className="whitespace-nowrap text-base font-semibold text-[#131313]">
          {t('chapterReport.reportTitle')}
        </strong>
      </div>
      <div className="flex flex-wrap items-center gap-4 text-sm text-[#333]">
        <span className="inline-flex items-center gap-2">
          <span className="grid size-6 place-items-center rounded-full bg-[#eee]">
            <img src="/report/diagnostic/icon-user.svg" alt="" className="size-3.5" />
          </span>
          <strong className="font-medium">{report.learner.fullName}</strong>
          {report.learner.gradeLevel && (
            <span className="text-xs text-[#4599ff]">
              {t('chapterReport.grade', { grade: formatGrade(report.learner.gradeLevel) })}
            </span>
          )}
        </span>
        <span className="inline-flex items-center gap-2">
          <span className="grid size-6 place-items-center rounded-full bg-[#eee]">
            <img src="/report/diagnostic/icon-calendar.svg" alt="" className="size-3.5" />
          </span>
          <span className="font-medium">{formatDate(report.latestTest.completedAt)}</span>
        </span>
      </div>
    </header>
  )
}
